import { apiClient } from "@/api";
import type { AgentListItem, PublicAgentDetail } from "@/types/agent";
import type { ApiResponse, PaginatedData } from "@/types";
import type { AxiosRequestConfig } from "axios";

export type SortOption = "newest" | "oldest" | "most_used" | "name";

interface GetPublicAgentsParams {
  page: number;
  limit: number;
  search?: string;
  sort?: SortOption;
}

export async function getPublicAgents(
  params: GetPublicAgentsParams,
  config?: AxiosRequestConfig,
): Promise<PaginatedData<AgentListItem>> {
  const { page, limit, search, sort = "newest" } = params;

  const { data } = await apiClient.get<ApiResponse<PaginatedData<AgentListItem>>>(
    "/agents/public",
    {
      ...config,
      params: {
        page,
        page_size: limit,
        search: search || undefined,
        sort,
      },
    },
  );

  return data.data!;
}

export async function getPublicAgent(agentId: string, config?: AxiosRequestConfig): Promise<PublicAgentDetail> {
  const { data } = await apiClient.get<ApiResponse<PublicAgentDetail>>(
    `/agents/public/${agentId}`,
    config,
  );
  return data.data!;
}
